<template>
<div>

    <div class="question">
        <h2>Questions les plus fréquentes</h2>
            <div class="question-accordion">
                <HomeQuestionAccordion >
                    <h3 slot="title">Nos garanties sérénité</h3>
                    <p slot="description">Chez Testachats, pas question de vous garder lié à un abonnement contre votre volonté. Grâce à notre garantie de satisfaction, vous êtes libre de mettre fin à votre affiliation quand vous le souhaitez. Il vous suffira de nous en avertir au plus tard 15 jours ouvrables avant chaque échéance mensuelle de votre abonnement*. Il n'y a donc pas d'obligation d'achat définitif puisque vous pouvez annuler votre abonnement à votre gré sans devoir nous fournir la moindre explication.</p>
                </HomeQuestionAccordion>
                <HomeQuestionAccordion >
                    <h3 slot="title">Que se passera-t-il après ma période d'essai ?</h3>
                    <p slot="description">Si vous souhaitez continuer à profiter de tous les services de Testachats après votre période d'essai, vous n'aurez rien à faire. Vous bénéficierez d'une réduction exceptionnelle de 50% durant toute votre première année d'abonnement et ne paierez donc que 12,33 € par mois au lieu de 24,66 €. C'est peu en comparaison des centaines d'euros d'économie que vous pourrez faire grâce à Testachats.</p>
                    <p slot="description">Vous pouvez résilier facilement votre abonnement en nous appelant au 02 891 37 01 ou en remplissant notre <span @click.prevent="openInfosModal('contact')">formulaire de contact.</span></p>
                </HomeQuestionAccordion>
            </div>
            <div class="question-desktop-container">
                <div class="question-container">
                    <h3>Nos garanties sérénité</h3>
                    <p>Chez Testachats, pas question de vous garder lié à un abonnement contre votre volonté. Grâce à notre garantie de satisfaction, vous êtes libre de mettre fin à votre affiliation quand vous le souhaitez. Il vous suffira de nous en avertir au plus tard 15 jours ouvrables avant chaque échéance mensuelle de votre abonnement*. Il n'y a donc pas d'obligation d'achat définitif puisque vous pouvez annuler votre abonnement à votre gré sans devoir nous fournir la moindre explication.</p>
                    <p>*Attention: tout mois entamé est considéré comme un mois entier.</p>
                </div>
                <div class="question-container">
                    <h3>Que se passera-t-il après ma période d'essai ?</h3>
                    <p>Si vous souhaitez continuer à profiter de tous les services de Testachats après votre période d'essai, vous n'aurez rien à faire. Vous bénéficierez d'une réduction exceptionnelle de 50% durant toute votre première année d'abonnement et ne paierez donc que 12,33 € par mois au lieu de 24,66 €. C'est peu en comparaison des centaines d'euros d'économie que vous pourrez faire grâce à Testachats.</p>
                    <p>Vous pouvez résilier facilement votre abonnement en nous appelant au 02 891 37 01 ou en remplissant notre <span @click.prevent="openInfosModal('contact')">formulaire de contact.</span></p>
                 </div>
            </div>
        <div class="link-container">
            <a @click.prevent="openInfosModal('faq')">Voir +</a>
        </div>
    </div>
</div>
</template>

<script>

import InfosModal from "../../modals/InfosModal";
import HomeQuestionAccordion from './HomeQuestionAccordion.vue';
export default {
  components: { HomeQuestionAccordion },
    name: "HomeQuestion",
    methods:{
        openInfosModal(tab) {
            this.$buefy.modal.open({
                component: InfosModal,
                props: {
                    activeTab: tab
                }
            })
        }
    }
}
</script>

<style scoped>

</style>
